<template>
  <card class="card-stats card3">
    <div class="row">
      <div class="col-5" v-if="$slots.header">
        <div class="icon-big text-center">
          <slot name="header"></slot>
        </div>
      </div>
      <div class="col-7" v-if="$slots.content">
        <div class="numbers">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
    <div slot="footer" class="stats" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </card>
</template>
<script>
  import Card from './Card.vue'
  export default {
    name: 'stats-card3',
    components: {
      Card
    }
  }

</script>
<style>
    .card3 {
        background-color: #ea7565 !important;
    }
    .card3 .card-title {
      color: #ffffff !important;
    } 
    .card3 .stats {
       color: #efeeee !important;
    } 
    .card3 .card-category {
       color: #f9f8f8 !important;
    }
</style>
